module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3",
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "form-control deficiency",
    attrs: {
      "readonly": _vm.readonly,
      "data-question": _vm.question,
      "name": _vm.name,
      "required": _vm.isRequired
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56cf3761"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/comment.vue
// module id = 982
// module chunks = 0